<template>
    <div class="sale-card">
        <div class="card-header" @click="$emit('edit-record', data)">
            <span :class="['status-badge', statusClass]">{{ data.sales_status ? data.sales_status.name : 'Sin estado'
                }}</span>

            <h5 class="card-title">
                <i class="fas fa-file-invoice-dollar"></i> Venta #{{ data.id }}
            </h5>
        </div>

        <div class="card-body" @click="$emit('edit-record', data)">
            <div class="info-section">
                <h6><i class="fas fa-user"></i> Paciente</h6>
                <p class="info-text">{{ data.patient ? `${data.patient.last_name} ${data.patient.first_name}` :
                    'No disponible' }}</p>
                <p class="info-subtext"><i class="fas fa-envelope"></i> {{ data.patient?.email || 'No disponible' }}</p>
            </div>

            <div class="info-section">
                <h6><i class="fas fa-user-md"></i> Médico</h6>
                <p class="info-text">{{ data.doctor ? data.doctor.name : 'No disponible' }}</p>
                <p class="info-subtext"><i class="fas fa-envelope"></i> {{ data.doctor?.email || 'No disponible' }}</p>
            </div>

            <div class="totals-section">
                <h6><i class="fas fa-receipt"></i> Detalles de Pago</h6>
                <ul>
                    <li><span>Monto Total:</span> <strong>${{ data.total_amount }}</strong></li>
                    <li><span>Descuento:</span> <strong>${{ data.discount }}</strong></li>
                    <li><span>Subtotal:</span> <strong>${{ data.subtotal }}</strong></li>
                    <li><span>IVA:</span> <strong>${{ data.tax }}</strong></li>
                    <li class="total"><span>Total a Pagar:</span> <strong>${{ data.final_amount }}</strong></li>
                </ul>
            </div>
            <div class="sale-date">
                <i class="fas fa-calendar-day"></i> {{ data.sale_date_format }}
            </div>
        </div>

        <div class="card-footer">
            <argon-button variant="gradient" @click="$emit('edit-record', data)"><i class="fa-solid fa-eye"></i>
                Ver</argon-button>
            <argon-button
v-if="!data.deleted_at" variant="gradient" color="danger"
                @click="$emit('delete-record', data)"><i class="fas fa-trash"></i> Eliminar</argon-button>
            <argon-button v-if="data.deleted_at" variant="gradient" @click="$emit('restore-record', data)"><i
                    class="fas fa-undo"></i> Restaurar</argon-button>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import ArgonButton from "@/components/ArgonButton.vue";

const props = defineProps({
    data: Object
});

const statusClass = computed(() => {
    const statusId = Number(props.data.sales_status?.id); // Convertir a número

    switch (statusId) {
        case 1: return 'status-open';
        case 2: return 'status-pending';
        case 3: return 'status-closed';
        case 4: return 'status-canceled';
        case 5: return 'status-partial';
        case 6: return 'status-in-progress';
        case 7: return 'status-completed';
        case 8: return 'status-refunded';
        case 9: return 'status-failed';
        case 10: return 'status-requested';
        case 11: return 'status-sent';
        case 12: return 'status-courtesy';
        case 13: return 'status-refunded-partial';
        default: return '';
    }
});


</script>

<style scoped>
/* ==== ESTILOS GENERALES ==== */
.sale-card {
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid #ddd;
    transition: transform 0.2s ease-in-out;
}

.card .card-body {
    padding: 0 16px;
}

.card-header:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.sale-card:hover {
    transform: translateY(-2px);
}

/* ==== ENCABEZADO ==== */
.card-header {
    background: linear-gradient(135deg, #4f4fff, #00aaff);
    color: white;
    text-align: center;
    padding: 16px;
    font-weight: bold;
    position: relative;
}

.card-title {
    font-size: 1.2rem;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #ffffff;
}

.sale-date {
    font-size: 0.9rem;
    margin: 10px 5px;
    top: 10px;
}

.status-badge:hover {
    transform: scale(1.05);
}

/* Ícono opcional */
.status-badge::before {
    font-size: 1rem;
}

/* ==== SECCIONES DE INFORMACIÓN ==== */
.card-body {
    padding: 10px;
}

.info-section {
    background: #f8f9fa;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 12px;
}

.info-section h6 {
    margin: 0;
    font-size: .7rem;
    color: rgba(72, 80, 87, 0.84);
    display: flex;
    align-items: center;
    gap: 6px;
}

.info-text {
    font-size: .9rem;
    font-weight: bold;
    margin: 0px 0 0;
    color: rgba(72, 80, 87, 0.84);
}

.info-subtext {
    font-size: .7rem;
    color: rgba(72, 80, 87, 0.84);
    margin: 2px 0 0;
}

/* ==== SECCIÓN DE TOTALES ==== */
.totals-section {
    padding: 12px;
    border-radius: 8px;
    border-left: 4px solid #ff9800;
    background: #fff3cd;
}

.totals-section h6 {
    font-size: 1rem;
    color: #ff9800;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0 0 8px;
}

.totals-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.totals-section li {
    display: flex;
    justify-content: space-between;
    font-size: 0.95rem;
    margin-bottom: 6px;
}

.totals-section .total {
    font-weight: bold;
    color: #66748e;
}

/* ==== PIE DE TARJETA Y BOTONES ==== */
.card-footer {
    display: flex;
    justify-content: space-between;
    padding: 12px;
    background: #f1f1f1;
}

.btn {
    flex: 1;
    padding: 10px;
    border: none;
    font-size: 0.9rem;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    margin: 0 4px;
}

.btn-edit {
    background: #007bff;
    color: white;
}

.btn-edit:hover {
    background: #0056b3;
}

.btn-delete {
    background: #dc3545;
    color: white;
}

.btn-delete:hover {
    background: #a71d2a;
}

.btn-restore {
    background: #28a745;
    color: white;
}

.btn-restore:hover {
    background: #1e7e34;
}

.status-open {
    background: linear-gradient(135deg, #4CAF50, #2E7D32);
    /* Verde intenso */
    color: white;
}

.status-pending {
    background: linear-gradient(135deg, #FFEB3B, #FBC02D);
    /* Amarillo dorado */
    color: #333;
}

.status-closed {
    background: linear-gradient(135deg, #9E9E9E, #616161);
    /* Gris metálico */
    color: white;
}

.status-canceled {
    background: linear-gradient(135deg, #FF5252, #D32F2F);
    /* Rojo vibrante */
    color: white;
}

.status-partial {
    background: linear-gradient(135deg, #00BCD4, #0288D1);
    /* Azul turquesa */
    color: white;
}

.status-in-progress {
    background: linear-gradient(135deg, #3D5AFE, #1E40AF);
    /* Azul profundo */
    color: white;
}

.status-completed {
    background: linear-gradient(135deg, #4CAF50, #388E3C);
    /* Verde esmeralda */
    color: white;
}

.status-refunded {
    background: linear-gradient(135deg, #E53935, #B71C1C);
    /* Rojo oscuro */
    color: white;
}

.status-failed {
    background: linear-gradient(135deg, #757575, #424242);
    /* Gris oscuro */
    color: white;
}

.status-requested {
    background: linear-gradient(135deg, #FFD600, #FFAB00);
    /* Amarillo brillante */
    color: #333;
}

.status-sent {
    background: linear-gradient(135deg, #2979FF, #1A73E8);
    /* Azul dinámico */
    color: white;
}

.status-courtesy {
    background: linear-gradient(135deg, #00ACC1, #00838F);
    /* Azul cyan */
    color: white;
}

.status-refunded-partial {
    background: linear-gradient(135deg, #8E24AA, #6A1B9A);
    /* Púrpura elegante */
    color: white;
}

/* ==== EFECTO GLASSMORPHISM ==== */
.status-badge {
    padding: 8px 16px;
    border-radius: 10px 0 0 10px;
    backdrop-filter: blur(8px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: bold;
    display: inline-block;
    text-align: center;
    transition: all 0.3s ease-in-out;
    position: absolute;
    top: 65px;
    right: 0px;
}

/* ==== Efecto Hover Suave ==== */
.status-badge:hover {
    transform: scale(1.05);
    filter: brightness(1.1);
}
</style>